import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import disciplinary_actionServices from "./disciplinary_reason.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getDisciplinaryAction = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_ACTION,
      payload: true,
    });
    const resp = await disciplinary_actionServices.getDisciplinaryAction(filters);
    dispatch({
      type: actions.GET_DISCIPLINARY_ACTION,
      payload: {
        disciplinaryAction: resp.data.data,
        disciplinaryActionLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.DISCIPLINARY_ACTION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.DISCIPLINARY_ACTION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_ACTION,
      payload: false,
    });
  }
};

export const saveDisciplinaryAction = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_DISCIPLINARY_ACTION,
      payload: true,
    });
    const resp = await disciplinary_actionServices.saveDisciplinaryAction(data);
    const { disciplinaryAction, disciplinaryActionLength } = getState().disciplinaryReason;
    const aDisciplinaryAction = [...disciplinaryAction, resp.data];
    dispatch({
      type: actions.GET_DISCIPLINARY_ACTION,
      payload: {
        disciplinaryAction: aDisciplinaryAction,
        disciplinaryActionLength: disciplinaryActionLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_DISCIPLINARY_ACTION,
      payload: false,
    });
  }
};

export const editDisciplinaryAction = (data, id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_ACTION,
      payload: true,
    });
    const resp = await disciplinary_actionServices.editDisciplinaryAction(id, data);
    const { disciplinaryAction, disciplinaryActionLength } = getState().disciplinaryReason;
    disciplinaryAction[index] = resp.data;
    dispatch({
      type: actions.GET_DISCIPLINARY_ACTION,
      payload: {
        disciplinaryAction: disciplinaryAction,
        disciplinaryActionLength: disciplinaryActionLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_ACTION,
      payload: false,
    });
  }
};

export const deleteDisciplinaryAction = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_ACTION,
      payload: true,
    });
    await disciplinary_actionServices.deleteDisciplinaryAction(id);
    const { disciplinaryAction, disciplinaryActionLength } = getState().disciplinaryReason;
    disciplinaryAction.splice(index, 1);
    dispatch({
      type: actions.GET_DISCIPLINARY_ACTION,
      payload: {
        disciplinaryAction: disciplinaryAction,
        disciplinaryActionLength: disciplinaryActionLength - 1,
      },
    });
    dispatch({
      type: actions.DISCIPLINARY_ACTION_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.DISCIPLINARY_ACTION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_DISCIPLINARY_ACTION,
      payload: false,
    });
  }
};
